"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateHearingRequest = exports.HighlightedHearing = exports.Hearing = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const case_schemas_1 = require("./case.schemas");
const highlight_schema_1 = require("./highlight.schema");
const joda_schemas_1 = require("./joda.schemas");
const HearingSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    title: case_schemas_1.CaseTitleSchema.nullable(),
    caseReference: case_schemas_1.CaseReferenceSchema,
    caseId: zod_1.default.string().uuid(),
    hearingSections: zod_1.default.array(case_schemas_1.HearingSection),
    recordingDate: joda_schemas_1.LocalDateSchema,
    courtSystemId: zod_1.default.string().uuid(),
    recordingId: zod_1.default.string().uuid(),
    locationId: zod_1.default.string().uuid(),
    previousHearingForCase: zod_1.default.string().uuid().nullable(),
    nextHearingForCase: zod_1.default.string().uuid().nullable(),
});
exports.Hearing = HearingSchema.refine((refine_1.is));
const HighlightedHearingSchema = HearingSchema.omit({
    previousHearingForCase: true,
    nextHearingForCase: true,
}).and(highlight_schema_1.HighlightedAndScored);
exports.HighlightedHearing = HighlightedHearingSchema.refine((refine_1.is));
const UpdateHearingRequestSchema = HearingSchema.pick({ caseReference: true, title: true });
exports.UpdateHearingRequest = UpdateHearingRequestSchema.refine((refine_1.is));
